export type TFiltersProps = {
  data?: any;
  changeHandler?: any;
};

export type TFilterOption = {
  filterName: string; // used to default open section
  filterColKey?: string;
  filterValues: { label: string; value: string }[];
  filterType?: any;
  selectedOptions?: string[]; // manage this array: checkbox return array of selected values eg: ['apple', 'pear']
};

/*
@author :  kishore
@desc commented the below filtersDataConst as it is not used anywhere
*/
// export const filtersDataConst: TFilterOption[] = [
//   {
//     filterName: "Program", // lable to display
//     selectedOptions: [], // manage this array: checkbox return array of selected values eg: ['apple', 'pear']
//     filterValues: [
//       { label: "Apple", value: "Apple" },
//       { label: "Pear", value: "Pear" },
//       { label: "Orange", value: "Orange" },
//     ],
//   },
//   {
//     filterName: "Case Status",
//     selectedOptions: [],
//     filterValues: [
//       { label: "Apple", value: "Apple" },
//       { label: "Pear", value: "Pear" },
//       { label: "Orange", value: "Orange" },
//     ],
//   },
//   {
//     filterName: "CM Status",
//     selectedOptions: [],
//     filterValues: [
//       { label: "Apple", value: "Apple" },
//       { label: "Pear", value: "Pear" },
//       { label: "Orange", value: "Orange" },
//     ],
//   },
//   {
//     filterName: "Updates",
//     selectedOptions: [],
//     filterValues: [
//       { label: "Apple", value: "Apple" },
//       { label: "Pear", value: "Pear" },
//       { label: "Orange", value: "Orange" },
//     ],
//   },
//   {
//     filterName: "Filter type",
//     selectedOptions: [],
//     filterValues: [
//       { label: "Apple", value: "Apple" },
//       { label: "Pear", value: "Pear" },
//       { label: "Orange", value: "Orange" },
//     ],
//   },
// ];

export const FilterTypes = {
 CRITERIA : 'ACTN-CRITERIA',
 MSELDRPDWN : 'ACTN-MSELDRPDWN',
 MULTIDRPDWN: 'ACTN-MULTIDRPDWN',
 FREETXT : 'ACTN-FREETXT',
 DATE : 'ACTN-DATE',
 DOLLAR_CRITERIA : 'ACTN-DOLLAR-CRITERIA',
 DATETIME : 'ACTN-DATETIME',
 CUSTOM_DATE : 'ACTN-CUSTOMDATE'
}

export const CriteriaDropdown = ['Deselect','Equal to','Greater Than','Greater & Equal','Less Than','Lesser & Equal','Between','Not Between'];